import { AbstractControl, ValidatorFn } from "@angular/forms";

export class UtilValidators {

    public static validatePhoneNumber(): ValidatorFn | any {
      return (control: AbstractControl) => {
        const value = control.value;

        if (value === '' || value == null) {
          return null;
        }

        const isValid = /^\+?[0-9]{9,}$/.test(value);

        return isValid ? null : { invalidPhoneNumber: true };
      };
    }

    public static validateBicLength(): ValidatorFn | any {
      return (control: AbstractControl) => {
        if (control.value === '' || control.value == null) return null;
        let isValid = false;

        if(control.value.length == 8 || control.value.length == 11){
          isValid = true;
        }
      
        return isValid ? null : { invalidBic: true };  
      }
    }

    public static isInvalidInvoiceDataType(): ValidatorFn | any {
      return (control: AbstractControl) => {
        if (control.value === '' || control.value == null) return null;
        let isValid = false;

        if(typeof control.value == 'object'){
          isValid = true;
        }
      
        return isValid ? null : { invalidInvoice: true };  
      }
    }
}